import { breakpoints } from '../utilities/breakpoints'

export const isTouchScreen =
  '@media (hover: none) and (pointer: coarse)' as const

export const isNotHoverDevice = '@media (hover: none)' as const

// TODO: Update variable name to something more appropriate as it is more than
// a phone in landscape only
export const isPhoneInLandscape = `@media
  screen and (max-width: ${breakpoints.Sizes.ExtraSmall}px),
  screen and (max-width: ${breakpoints.Sizes.Small}px) and (orientation: landscape) and (hover: none)
` as const

/**
 * At a certain point the content becomes so height constrained that the
 * header and footer can take up 80% of viewport height making the body unscrollable. This
 * become most apparent when browser is zoomed between 200%-400% (accessibility
 * requirement)
 */
export const isHeightConstrained =
  `@media screen and (max-height: 403px)` as const

export const prefersContrast = `@media (prefers-contrast: more)` as const
